import { UI, Stack, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';

import {
  ColorCodedText,
  ColorCodedTextProps,
} from '../../../../../../../../../components/ColorCodedText';
import { OperationType } from '../../../../../../../../../components/OperationType';
import { ProductFieldProps } from '../../../../constants';

interface AssetCardInfoProps<T> {
  item: T;
  info: ProductFieldProps<T>;
  rows: number;
  columns: number;
}

export const AssetCardInfo = <T,>({ item, info, rows, columns }: AssetCardInfoProps<T>) => {
  const renderValue = () => {
    if (info.coloredField) {
      return (
        <ColorCodedText
          sign={item[info.coloredField] as ColorCodedTextProps['sign']}
          text={`${item[info.key]}`}
        />
      );
    }
    if (info.highlighted) {
      return (
        <Stack alignSelf="flex-start">
          <OperationType title={`${item[info.key]}`} />
        </Stack>
      );
    }
    return <UI.Text color={'neutral.dark'}>{`${item[info.key]}`}</UI.Text>;
  };

  return (
    <VStack w={rows !== 1 ? `${100 / columns}%` : undefined} space={'stack.quarck'}>
      <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.black">
        {info.label}
      </UI.Text>
      {renderValue()}
    </VStack>
  );
};
